// Service worker registration for AfriHR PWA shell.
// Registers only in production builds and only when the browser supports
// service workers. Auto-reloads exactly once when a new SW takes control
// so users always run the latest deployed assets.

export function registerServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  if (process.env.NODE_ENV !== 'production') return;
  if (!['http:', 'https:'].includes(window.location.protocol)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((error) => {
        // Service worker is optional — log and continue.
        // eslint-disable-next-line no-console
        console.warn('AfriHR service worker registration failed:', error);
      });

    let hasReloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (hasReloaded) return;
      hasReloaded = true;
      window.location.reload();
    });
  });
}

export function unregisterServiceWorker() {
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch(() => undefined);
}
